<template>
  <div v-show="message" data-test="input-warning">
    <WebWarningMessage>{{ capitalizeMessage }}</WebWarningMessage>
  </div>
</template>

<script>
import WebWarningMessage from '@/Web/Components/WebWarningMessage.vue'

export default {
  components: { WebWarningMessage },

  props: {
    message: {
      type: String,
      default: '',
    },
  },

  computed: {
    capitalizeMessage() {
      return this.message.charAt(0).toUpperCase() + this.message.slice(1)
    },
  },
}
</script>
